import WasteHeader from "./Header";
import "./index.css";
import { useState } from "react";
import { ShowHide } from "../components/ShowHideCompany";
import SurplusMaterialContents from "./SurplusMaterials/SurplusMaterial";
import CustomWasteContents from "./SurplusMaterials/CustomWaste";
import WasteWaterContent from "./Water";
import WasteEnergyContent from "./Energy";
import FlowNumbersBox from "../components/FlowNumbersBox";
import EPRBox from "../components/EPRBox";
const SurplusResourceComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="surplus-resource-container" id="waste-id">
      <WasteHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        {show && (
          <EPRBox
            businessId={businessId}
            mainBusinessId={mainBusinessId}
            category={"Surplus Resources"}
          />
        )}
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 8.1"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && <SurplusMaterialContents businessId={businessId} />}
      {show && <CustomWasteContents businessId={businessId} />}
      {show && <WasteWaterContent businessId={businessId} />}
      {show && <WasteEnergyContent businessId={businessId} />}
    </div>
  );
};

export default SurplusResourceComponent;
